function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#yayicon .cls-1{isolation:isolate;}#yayicon .cls-2{fill:#fcd226;}#yayicon .cls-3{fill:#fdeb4e;}#yayicon .cls-4{fill:#f7b722;}#yayicon .cls-5{fill:#88271f;#yayicon .cls-6{fill:#f3ab2f;opacity:0.7;mix-blend-mode:multiply;}.cls-7{fill:#811c1a;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M0,14S.49,8.21,3.55,5.28,9.56.4,15.76,0,25.83,5.91,26.43,7s2.38,4.44,2.38,7,0,8-3.65,10.38-7.2,3.8-9.74,3.67-8.93-.67-11.8-4.67S0,18.14,0,14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M14.91,3a5.14,5.14,0,0,1,3.91.45.18.18,0,0,0,.25-.24c-.55-1-2-2.83-4.32-.51A.17.17,0,0,0,14.91,3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M9.14,25.43c-1.5-1.55-3.5-3.5-3.3-10.2S7.64,6.16,8.79,4.38A15.15,15.15,0,0,1,14.24.15,16.51,16.51,0,0,0,3.55,5.28C.49,8.21,0,14,0,14c0,4.09.75,5.37,3.62,9.38s9.27,4.53,11.8,4.66C15.42,28.08,10.64,27,9.14,25.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M5.45,12s2.2-1.62,4-1.28,3.3,1.06,2.8-.28S8.4,8.79,8.4,8.79s-2.2,1.35-2.35,1.4-2.31,1.37-2.31,1.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M19.86,10.28s-.07.9.6.8,1.5-1.05,2.9-.66,2.48.67,2.43,0-2.07-1.94-2.07-1.94L21,9.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M4.63,11.44s-.31-.26.42-1.1a14.77,14.77,0,0,1,3.4-2.73,2.7,2.7,0,0,1,3,.87c1.14,1.26,1.44,2,1.1,2.26s-.86-.23-1.36-.6a3.09,3.09,0,0,0-3.07-.46C6.35,10.21,5.18,12,4.63,11.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M19.66,10.58s-.5-.6.26-1.34A9.13,9.13,0,0,1,22,7.61a2,2,0,0,1,2.5.6c.94,1.13,1.8,2.13,1.44,2.37s-1.27-.5-1.7-.8a1.94,1.94,0,0,0-2.7.1C21,10.34,20.32,11.11,19.66,10.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M4,15.64A3.83,3.83,0,0,1,8,12.12a3.82,3.82,0,0,1,4.06,3.52A3.82,3.82,0,0,1,8,19.17,3.83,3.83,0,0,1,4,15.64Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-6",
  cx: 24.83,
  cy: 15.04,
  rx: 2.86,
  ry: 2.92
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M10.67,19.07c.59-.35,1,.13,1.36.4a8.9,8.9,0,0,0,4.09,1.84,5.07,5.07,0,0,0,5.34-2.45c.26-.41.47-1.29,1.08-1s0,1-.18,1.49l0,.08a5.78,5.78,0,0,1-3.56,3,7.86,7.86,0,0,1-5.68-.27,5.51,5.51,0,0,1-2.18-1.88A1.18,1.18,0,0,1,10.67,19.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M10.67,19.07c.26,1.67,2.2,3.19,4.29,3.48a7.37,7.37,0,0,0,7.37-3.09c0,1.12-.86,1.71-1.57,2.32A7.43,7.43,0,0,1,11,21.12C10.51,20.56,9.93,19.9,10.67,19.07Z"
}))));

var SvgYay = function SvgYay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "yayicon",
    viewBox: "0 0 28.81 28.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yay.17f70272.svg";
export { ForwardRef as ReactComponent };